<template>
  <div ref="needThisRefForSomeReason">
    <template>
      <div ref="subTable">
        <div>
          <div>
            <div
              v-for="(message, messageIndex) in messages"
              v-bind:key="messageIndex"
            >
              {{ message }}
            </div>
            <!-- <div v-if="hasMissing">- Estimate could not be computed. Some estimates cannot be computed when the denominator sample size is 0, though other causes may exist as well.</div>
            <div v-if="isDataUnreliable">* Estimate not available if the unweighted sample size for the denominator was < 50 or the Relative Standard Error (RSE) is > 0.3.</div>
            <div v-if="noSourceRecords">** No data available</div>
            <div v-if="hasNoCellResponses">*** No responses for this data cell</div> -->
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import store from "@/store";

function addFootnotesToSpreadsheet(sheet) {
  let vm = this;
  vm.messages.forEach((m) => sheet.addRow(["", m]));
  if (vm.messages.length > 0) sheet.addRow([""]); //Add a blank row
}

/* eslint no-unused-vars: 'off' */

export default {
  props: [
    "control1",
    "control2",
    "hasNoCellResponses",
    "noSourceRecords",
    "isDataUnreliable",
  ],
  mounted: function () {
    const vm = this;
    //We are only setting width
    store.dispatch("loadedControls/mounted", {
      name: "footnotes",
      control1: vm.control1,
      control2: vm.control2,
      vm,
      subTable: vm.$refs.subTable,
    });
  },
  data: function () {
    var vm = this;
    let hasMissing = vm.control2 ? vm.any(this.control2, "isMissing") : false;
    let messages = [];
    if (hasMissing)
      messages.push(
        "- Estimate could not be computed. Some estimates cannot be computed when the denominator sample size is 0, though other causes may exist as well."
      );
    if (vm.isDataUnreliable)
      messages.push(
        "* Estimate not available if the unweighted sample size for the denominator was < 50 or the Relative Standard Error (RSE) is > 0.3."
      );
    if (vm.noSourceRecords) messages.push("** No data available");
    if (vm.hasNoCellResponses)
      messages.push("*** No responses for this data cell");
    return {
      messages,
    };

    // if (vm.control2)
    //   return {
    //     hasMissing: this.any(this.control2, 'isMissing')
    //     //isSampleTooSmall: this.any(this.control2, 'isSampleTooSmall')
    //   }
    // else
    //   return {
    //     hasMissing: false
    //     //isSampleTooSmall: false
    //   }
  },
  methods: {
    addFootnotesToSpreadsheet,
    any: function (control2, property) {
      var vm = this;
      //console.log('1', control2.levelsGroupedByRows);
      return (
        control2.levelsGroupedByRows.filter((s) =>
          vm.anyRowHasStat(s, property)
        ).length > 0
      );
    },
    anyRowHasStat: function (row, property) {
      var vm = this;
      //console.log('2', row);
      return (
        row.columnStatistics.filter((c) => vm.anyColumnHasStat(c, property))
          .length > 0 ||
        vm.anyColumnHasStat(row.totalStatistics, property).length > 0
      );
      //return Object.keys(row).filter(k => k !== 'rowLevel' && vm.anyColumnHasStat(row[k], property, k));
    },
    anyColumnHasStat: function (stats, property) {
      var vm = this;
      if (stats === undefined || stats === null) return false;
      //console.log('3', stats);
      var results =
        (stats.columnPercentage !== undefined &&
          stats.columnPercentage !== null &&
          stats.columnPercentage[property]) ||
        (stats.rowPercentage !== undefined &&
          stats.rowPercentage !== null &&
          stats.rowPercentage[property]) ||
        (stats.totalPercentage !== undefined &&
          stats.totalPercentage !== null &&
          stats.totalPercentage[property]) ||
        (stats.weightedN !== undefined &&
          stats.weightedN !== null &&
          stats.weightedN[property]);
      return results;
    },
  },
};
</script>

<style scoped>
.row {
  margin: 0px 0px 20px 0px;
}
</style>
